<template>
  <div class="main_equip">
    <div v-if="list.length > 0">
      <div class="main_equip_image">
        <el-image class="image" lazy :src="list[listIndex].logo" fit="cover">
          <div slot="error" class="image_error">暂无图片</div>
        </el-image>
      </div>
      <div class="main_equip_content pointer" @click="toDetail(list[listIndex].id)">
        <h2 class="main_equip_content_title">{{ list[listIndex].title }}</h2>
        <p class="main_equip_content_time" @mouseenter="hoverFlag = true" @mouseleave="hoverFlag = false"><img v-if="!hoverFlag" src="@/assets/clock-icon.png" /><img v-if="hoverFlag" src="@/assets/clock-h-icon.png" /><span>发布日期 {{ list[listIndex].createdAt | dateFormat }}</span></p>
        <p class="main_equip_content_text">{{ list[listIndex].content }}</p>
        <div class="main_equip_content_images">
          <el-image v-for="(item, index) in list" :key="item.id" v-if="index < 3" @click.stop="listIndex = index" class="image pointer" :src="item.logo" fit="cover">
            <div slot="error" class="image_error">暂无图片</div>
          </el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mainEquip',
  props: ['dxzb'],
  data () {
    return {
      listIndex: 0,
      hoverFlag: false
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {
    list () {
      return this.dxzb
    }
  },
  methods: {
    toDetail (itemId) {
      this.$router.push({
        path: '/equip/detail',
        query: {
          itemId: itemId
        }
      })
    }
  },
  watch: {}
}
</script>

<style scoped>
  .main_equip { width: 100%; height: 330px; border: 1px solid #DCDFE6; margin-bottom: 20px; border-radius: 2px; }
  .main_equip > div { width: 100%; height: 100%; }
  .main_equip .main_equip_image { float: left; width: 50%; height: 328px; }
  .main_equip .main_equip_image .image { width: 100%; height: 100%; border-radius: 2px; }
  .main_equip .main_equip_content { float: left; width: 50%; height: 100%; padding: 10px; position: relative; }
  .main_equip .main_equip_content .main_equip_content_title { font-size: 18px; font-weight: 600; color: #333333; line-height: 25px; margin-bottom: 10px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
  .main_equip .main_equip_content .main_equip_content_time { margin-bottom: 10px; }
  .main_equip .main_equip_content .main_equip_content_time img { width: 12px; height: 12px; margin-right: 5px; }
  .main_equip .main_equip_content .main_equip_content_time span { font-size: 12px; font-weight: 400; color: #999999; line-height: 12px; }
  .main_equip .main_equip_content .main_equip_content_text { height: 100px; font-size: 14px; font-weight: 400; color: rgba(102,102,102,1); line-height: 20px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 5; -webkit-box-orient: vertical; }
  .main_equip .main_equip_content .main_equip_content_images { position: absolute; width: 100%; height: 120px; bottom: 0; left: 0; padding: 10px; }
  .main_equip .main_equip_content .main_equip_content_images .image { width: 153px; height: 100px; float: left; margin-right: 10px; transition: 0.6s }
  .main_equip .main_equip_content .main_equip_content_images .image:hover { transform: scale(1.08); }
  .main_equip .main_equip_content .main_equip_content_images .image:last-child {  margin-right: 0px; }
  .main_equip .main_equip_content .main_equip_content_title:hover, .main_equip .main_equip_content .main_equip_content_text:hover { color: #76BF28; }
  .main_equip .main_equip_content .main_equip_content_time:hover span { color: #99C767; }
</style>



// WEBPACK FOOTER //
// src/components/main/equip.vue